export const heroData = {
  tag: "🔥 实时追踪 · 每日更新",
  h1: "每日大赛黑料 · 全网赛事内幕第一站",
  slogan: "吃瓜不迷路，黑料早知道",
  intro: "每日大赛黑料网是国内领先的赛事八卦与黑料爆料聚合平台，覆盖电竞联赛、综艺选秀、体育竞技等热门赛道。我们每日追踪大赛内幕，深度揭秘不为人知的幕后故事，为你呈现最鲜活的今日吃瓜黑料。无论你是资深吃瓜群众还是刚入坑的八卦爱好者，这里都有你想看的每日爆料最新动态。",
  stats: [
    { label: "覆盖赛种", value: "30+" },
    { label: "每日更新", value: "50+条" },
    { label: "独家深挖", value: "200+篇" },
  ],
  primaryCta: { text: "立即吃瓜", href: "#cards" },
  secondaryCta: { text: "今日快讯", href: "#updates" },
};

export const cardsData = [
  {
    id: 1,
    tag: "独家深挖",
    title: "某顶流电竞选手私下签约竞品战队，天价违约金曝光",
    excerpt: "据知情人士透露，该选手在合同期内秘密接触多家战队，最终与其中一家达成私下协议，涉及违约金高达八位数。此事已在圈内引发轩然大波。",
    image: "https://readdy.ai/api/search-image?query=Dark%20dramatic%20esports%20arena%20with%20silhouetted%20figure%20under%20spotlight%2C%20red%20and%20black%20color%20scheme%2C%20cinematic%20lighting%20with%20deep%20shadows%2C%20mysterious%20competitive%20gaming%20atmosphere%2C%20editorial%20photography%20style%2C%20high%20contrast%2C%20tense%20mood%2C%20no%20text%20overlay%2C%20dark%20background%20with%20subtle%20red%20accents&width=800&height=500&seq=card-01&orientation=landscape",
    date: "3小时前",
    hot: true,
  },
  {
    id: 2,
    tag: "内幕揭秘",
    title: "选秀节目暗箱操作曝光：导师打分系统存在人为操控",
    excerpt: "内部工作人员爆料，某知名选秀节目的导师评分并非实时生成，而是由节目组提前拟定排名后再分配分数。多位选手的命运早在录制前就被决定。",
    image: "https://readdy.ai/api/search-image?query=Dramatic%20talent%20show%20stage%20with%20spotlight%20and%20dark%20atmosphere%2C%20red%20curtain%20background%2C%20mysterious%20behind%20the%20scenes%20vibe%2C%20cinematic%20lighting%2C%20shadowy%20figures%2C%20high%20contrast%20dark%20mood%2C%20editorial%20photography%2C%20judges%20table%20silhouette&width=800&height=500&seq=card-02&orientation=landscape",
    date: "5小时前",
    hot: true,
  },
  {
    id: 3,
    tag: "黑料吃瓜",
    title: "体育赛事裁判受贿链条曝光，多场比赛结果疑被操纵",
    excerpt: "一组涉及三名国际级裁判的受贿证据近日浮出水面，至少涉及过去两年内的十二场重要赛事。相关机构已启动紧急调查程序，涉事裁判已被暂停执裁资格。",
    image: "https://readdy.ai/api/search-image?query=Dark%20sports%20stadium%20at%20night%20with%20dramatic%20lighting%2C%20empty%20field%20under%20floodlights%2C%20mysterious%20tense%20atmosphere%2C%20red%20and%20black%20color%20palette%2C%20cinematic%20wide%20shot%2C%20deep%20shadows%2C%20editorial%20style%2C%20corruption%20theme%20vibe&width=800&height=500&seq=card-03&orientation=landscape",
    date: "8小时前",
    hot: false,
  },
  {
    id: 4,
    tag: "深度爆料",
    title: "知名赛事赞助商涉嫌数据造假，合作方纷纷解约",
    excerpt: "一份第三方审计报告揭示，某顶级赛事冠名赞助商在过去三年间持续夸大用户数据，以此获取更高额的赞助权益。目前已有五家赛事运营方宣布终止合作。",
    image: "https://readdy.ai/api/search-image?query=Corporate%20boardroom%20in%20dark%20dramatic%20lighting%2C%20documents%20spread%20on%20table%2C%20red%20accent%20highlights%2C%20tense%20business%20negotiation%20atmosphere%2C%20cinematic%20photography%2C%20deep%20shadows%2C%20mysterious%20mood%2C%20dark%20color%20scheme%20with%20subtle%20gold%20accents&width=800&height=500&seq=card-04&orientation=landscape",
    date: "12小时前",
    hot: false,
  },
  {
    id: 5,
    tag: "今日吃瓜",
    title: "两大赛事主办方为争夺头部选手爆发公开冲突",
    excerpt: "国内两大顶级电竞赛事联盟因一位明星选手的参赛资格问题产生激烈争执，双方各执一词并在社交媒体上公开对峙，引发粉丝群体大规模论战。",
    image: "https://readdy.ai/api/search-image?query=Two%20opposing%20forces%20facing%20off%20in%20dark%20arena%2C%20dramatic%20red%20versus%20blue%20lighting%20split%2C%20competitive%20confrontation%20atmosphere%2C%20cinematic%20composition%2C%20deep%20contrast%2C%20editorial%20style%2C%20tense%20standoff%20vibe&width=800&height=500&seq=card-05&orientation=landscape",
    date: "1天前",
    hot: true,
  },
];

export const indexData = [
  {
    id: 1,
    title: "电竞圈黑料档案",
    desc: "LPL、KPL等顶级赛事不为人知的幕后故事",
    count: 89,
    icon: "ri-gamepad-line",
    color: "primary",
  },
  {
    id: 2,
    title: "选秀节目深扒",
    desc: "创造营、好声音等综艺暗箱操作实录",
    count: 67,
    icon: "ri-mic-line",
    color: "accent",
  },
  {
    id: 3,
    title: "体育裁判风波",
    desc: "国内外体育赛事判罚争议与内幕追踪",
    count: 54,
    icon: "ri-flag-line",
    color: "primary",
  },
  {
    id: 4,
    title: "赞助商黑幕",
    desc: "品牌赞助背后的利益输送与数据造假",
    count: 42,
    icon: "ri-money-dollar-circle-line",
    color: "accent",
  },
  {
    id: 5,
    title: "选手合同纠纷",
    desc: "天价违约金、私下挖角与转会暗战",
    count: 73,
    icon: "ri-file-text-line",
    color: "primary",
  },
  {
    id: 6,
    title: "赛事造假调查",
    desc: "假赛、操纵比分与博彩链条全揭秘",
    count: 61,
    icon: "ri-search-eye-line",
    color: "accent",
  },
  {
    id: 7,
    title: "直播平台乱象",
    desc: "主播争议、平台数据注水与工会骗局",
    count: 48,
    icon: "ri-live-line",
    color: "primary",
  },
  {
    id: 8,
    title: "娱乐圈赛事",
    desc: "明星参与赛事的八卦与幕后交易",
    count: 55,
    icon: "ri-star-line",
    color: "accent",
  },
  {
    id: 9,
    title: "粉丝圈生态",
    desc: "粉丝经济、数据打投与后援会内斗",
    count: 36,
    icon: "ri-heart-line",
    color: "primary",
  },
];

export const updatesData = [
  {
    id: 1,
    time: "10分钟前",
    title: "知名电竞选手深夜发文暗指战队内部不和，引发粉丝担忧",
    tag: "最新",
  },
  {
    id: 2,
    time: "30分钟前",
    title: "某省级赛事被曝使用未授权音乐，版权方正式发函警告",
    tag: "快讯",
  },
  {
    id: 3,
    time: "1小时前",
    title: "选秀节目选手遭恶意剪辑，原片流出后舆论瞬间反转",
    tag: "热点",
  },
  {
    id: 4,
    time: "2小时前",
    title: "国际赛事裁判长因涉嫌利益冲突被紧急替换",
    tag: "突发",
  },
  {
    id: 5,
    time: "3小时前",
    title: "知名主播被曝直播间数据造假，平台已介入核查",
    tag: "快讯",
  },
  {
    id: 6,
    time: "5小时前",
    title: "赛事赞助品牌因质量问题被约谈，多场活动被迫延期",
    tag: "跟进",
  },
  {
    id: 7,
    time: "7小时前",
    title: "退役选手转型教练后首度回应过往争议事件",
    tag: "独家",
  },
  {
    id: 8,
    time: "9小时前",
    title: "两大直播平台为争夺赛事版权再次对簿公堂",
    tag: "快讯",
  },
  {
    id: 9,
    time: "12小时前",
    title: "年度赛事评奖被质疑暗箱操作，主办方紧急回应",
    tag: "热点",
  },
];

export const featuresData = [
  {
    id: 1,
    icon: "ri-shield-flash-line",
    title: "爆料人保护",
    desc: "严格保护每一位爆料人的身份信息，采用多层加密技术确保隐私安全，让知情人敢于说出真相。",
  },
  {
    id: 2,
    icon: "ri-timer-flash-line",
    title: "实时追踪",
    desc: "7×24小时不间断监控各大赛事动态，第一时间推送黑料更新，让你永远快人一步掌握内幕。",
  },
  {
    id: 3,
    icon: "ri-spy-line",
    title: "深度调查",
    desc: "专业调查团队深入一线，多方交叉验证信息真实性，为你还原赛事背后最完整的事件真相。",
  },
  {
    id: 4,
    icon: "ri-group-line",
    title: "吃瓜社区",
    desc: "汇聚百万吃瓜群众，热门话题开放讨论，理性分析与非理性吐槽并存，打造最活跃的八卦交流圈。",
  },
];

export const commentsData = [
  {
    id: 1,
    avatar: "匿",
    name: "吃瓜不嫌事大",
    time: "2小时前",
    content: "这个裁判受贿的料真的太大了！我就说那几场比赛判罚明显不对劲，现在看来果然有问题。希望官方能严肃处理，别又是罚酒三杯就完事了。",
    likes: 1283,
    tag: "热评",
  },
  {
    id: 2,
    avatar: "爆",
    name: "电竞圈老司机",
    time: "4小时前",
    content: "选手私下签约这事在圈内早就不是秘密了，只是没人敢公开说而已。这次曝光出来的细节比我之前听说的还要劲爆，天价违约金那段看得我头皮发麻。",
    likes: 967,
    tag: "精选",
  },
  {
    id: 3,
    avatar: "瓜",
    name: "今日份大瓜",
    time: "6小时前",
    content: "选秀节目暗箱操作这个我信，之前我朋友去现场当过观众，回来就说节目的投票器和实际统计根本对不上。只是没想到这次连导师打分都有猫腻，太离谱了。",
    likes: 756,
    tag: "热议",
  },
];

export const appData = {
  tag: "随时随地 · 吃瓜不停",
  title: "下载每日大赛黑料 APP",
  desc: "移动端专属优化，推送更快更及时。离线也能看已加载的黑料内容，地铁通勤、排队等候都不错过任何大瓜。支持夜间模式，深色主题护眼不刺眼。",
  features: ["极速推送通知", "离线阅读模式", "夜间护眼主题", "一键分享吃瓜"],
  qrImage: "https://readdy.ai/api/search-image?query=Dark%20themed%20QR%20code%20design%20with%20red%20accents%2C%20minimal%20geometric%20pattern%2C%20modern%20tech%20style%2C%20dark%20background%20with%20subtle%20gradient%2C%20clean%20and%20sharp%20design&width=400&height=400&seq=app-qr-01&orientation=squarish",
  appImage: "https://readdy.ai/api/search-image?query=Smartphone%20mockup%20showing%20dark%20themed%20news%20app%20interface%20with%20red%20accent%20highlights%2C%20modern%20UI%20design%2C%20scandal%20news%20headlines%20on%20screen%2C%20minimal%20phone%20frame%2C%20dark%20background%2C%20clean%20product%20photography&width=600&height=800&seq=app-phone-01&orientation=portrait",
};

export const topicsData = [
  { id: 1, name: "电竞黑料", heat: "98.7万讨论", hot: true },
  { id: 2, name: "选秀内幕", heat: "86.3万讨论", hot: true },
  { id: 3, name: "裁判受贿", heat: "72.1万讨论", hot: true },
  { id: 4, name: "选手转会", heat: "65.8万讨论", hot: false },
  { id: 5, name: "赞助商造假", heat: "54.2万讨论", hot: false },
  { id: 6, name: "数据注水", heat: "48.9万讨论", hot: false },
  { id: 7, name: "假赛调查", heat: "43.5万讨论", hot: true },
  { id: 8, name: "合同纠纷", heat: "38.7万讨论", hot: false },
  { id: 9, name: "直播乱象", heat: "32.4万讨论", hot: false },
  { id: 10, name: "粉丝大战", heat: "28.1万讨论", hot: false },
];

export const contactData = {
  tag: "有料就爆",
  title: "投稿爆料 · 联系我们",
  desc: "如果你掌握任何赛事相关的一手内幕信息，欢迎通过以下方式联系我们。我们承诺严格保密爆料人信息，并为高质量独家爆料提供丰厚稿酬。你的每一次爆料，都在让赛事环境更加透明。",
  tips: ["爆料内容需真实可靠，请提供可验证的证据材料", "我们会在24小时内回复所有有效爆料", "重大独家爆料最高可获得五位数稿酬"],
  email: "tips@mrdshl.com",
};

export const faqData = [
  {
    id: 1,
    q: "每日大赛黑料网的内容来源是什么？",
    a: "我们的内容主要来自三个渠道：专业调查团队的深度挖掘、行业内部知情人士的匿名爆料，以及对公开赛事数据和信息的交叉分析。所有发布内容都经过多轮事实核查，确保信息准确可靠。",
  },
  {
    id: 2,
    q: "如何向平台投稿爆料？",
    a: "你可以通过页面底部的联系方式或投稿专区向我们提交爆料信息。请尽可能提供详细的证据材料（截图、录音、文件等），我们会安排专人对接并在核实后给予相应稿酬。",
  },
  {
    id: 3,
    q: "爆料人的个人信息是否安全？",
    a: "我们采用银行级别的加密技术保护每一位爆料人的身份信息。所有爆料资料在传输和存储过程中均经过多层加密处理，只有核心审核团队可以接触原始信息，绝不对外泄露。",
  },
  {
    id: 4,
    q: "平台发布的内容是否会造成法律风险？",
    a: "我们有专业法律顾问团队对每一篇深度爆料内容进行合规审查，确保所有发布内容符合相关法律法规要求。对于不能充分验证的信息，我们会明确标注'未经证实'等提示，由读者自行判断。",
  },
];

export const carouselData = [
  {
    id: 1,
    title: "电竞顶流选手天价跳槽：八位数违约金背后的资本暗战",
    desc: "一场看似普通的选手转会，背后牵扯出三家资本方的明争暗斗。独家揭秘这场转会风波中的利益纠葛与隐秘协议。",
    image: "https://readdy.ai/api/search-image?query=Dark%20dramatic%20esports%20arena%20with%20epic%20lighting%2C%20gaming%20championship%20stage%2C%20red%20and%20black%20atmosphere%2C%20cinematic%20wide%20shot%2C%20professional%20photography%2C%20high%20contrast%2C%20intense%20competitive%20mood%2C%20spotlight%20on%20center&width=1200&height=600&seq=carousel-01&orientation=landscape",
    tag: "独家深度",
    badge: "本周最热",
  },
  {
    id: 2,
    title: "选秀帝国崩塌前夕：三大节目被曝系统性数据造假",
    desc: "跨越三年的调查揭示了一个庞大的造假网络——从收视率到投票数，从热搜排名到选手人气，几乎没有什么是真实的。",
    image: "https://readdy.ai/api/search-image?query=Dramatic%20talent%20show%20stage%20with%20collapsing%20visual%20metaphor%2C%20dark%20theatrical%20atmosphere%2C%20red%20curtains%20and%20spotlight%2C%20cinematic%20composition%2C%20high%20contrast%20photography%2C%20grand%20scale%2C%20mysterious%20mood&width=1200&height=600&seq=carousel-02&orientation=landscape",
    tag: "系列调查",
    badge: "持续更新",
  },
  {
    id: 3,
    title: "国际裁判受贿链条全揭秘：十二场关键比赛被操纵",
    desc: "从亚洲到欧洲，从足球到电竞，一个横跨多国多赛事的裁判受贿网络正在被逐层揭开。已有三名裁判被暂停执裁资格。",
    image: "https://readdy.ai/api/search-image?query=Dark%20sports%20referee%20silhouette%20in%20empty%20stadium%2C%20dramatic%20lighting%20with%20red%20accents%2C%20cinematic%20wide%20angle%2C%20corruption%20theme%2C%20high%20contrast%2C%20professional%20photography%2C%20tense%20atmosphere&width=1200&height=600&seq=carousel-03&orientation=landscape",
    tag: "深度调查",
    badge: "重磅曝光",
  },
  {
    id: 4,
    title: "赞助商的隐秘世界：品牌赛事合作中那些不能说的事",
    desc: "表面光鲜的赛事赞助背后，隐藏着数据造假、利益输送和暗箱操作。一份内部文件揭开这个价值千亿产业的灰色地带。",
    image: "https://readdy.ai/api/search-image?query=Luxury%20corporate%20event%20with%20dark%20mysterious%20atmosphere%2C%20red%20and%20gold%20accent%20lighting%2C%20brand%20logos%20in%20shadows%2C%20cinematic%20composition%2C%20high%20contrast%2C%20editorial%20photography%20style&width=1200&height=600&seq=carousel-04&orientation=landscape",
    tag: "商业深挖",
    badge: "独家首发",
  },
  {
    id: 5,
    title: "直播平台数据注水内幕：你看到的百万观众可能只有几千",
    desc: "技术团队通过逆向分析揭示了多家直播平台的数据造假手法。从机器人观众到虚假弹幕，这场造假狂欢远比想象中更加普遍。",
    image: "https://readdy.ai/api/search-image?query=Dark%20server%20room%20with%20red%20glowing%20data%20visualizations%2C%20cyber%20mysterious%20atmosphere%2C%20digital%20deception%20theme%2C%20cinematic%20lighting%2C%20high%20tech%20yet%20ominous%20mood%2C%20editorial%20photography&width=1200&height=600&seq=carousel-05&orientation=landscape",
    tag: "技术揭秘",
    badge: "强烈推荐",
  },
];

export const aboutData = {
  title: "关于每日大赛黑料网",
  desc1: "每日大赛黑料网创立于2023年，是国内首个专注于赛事领域黑料爆料与深度揭秘的独立资讯平台。我们致力于打破赛事行业的信息壁垒，通过专业调查和匿名爆料双渠道，为公众呈现赛事背后最真实的一面。",
  desc2: "我们的团队由资深体育记者、电竞行业分析师、数据调查专家和法律顾问组成，确保每一篇爆料内容在追求真相的同时，也严格遵守新闻伦理与法律规范。我们不站队、不偏袒，只做事实的搬运工和真相的放大镜。",
  stats: [
    { label: "运营天数", value: "1,200+" },
    { label: "累计爆料", value: "3,500+篇" },
    { label: "独家深挖", value: "800+篇" },
    { label: "月活用户", value: "500万+" },
  ],
};

export const mediaData = [
  {
    id: 1,
    title: "【独家采访】退役裁判首次公开谈受贿内幕",
    duration: "28:45",
    views: "128万",
    image: "https://readdy.ai/api/search-image?query=Interview%20studio%20with%20dramatic%20lighting%20and%20dark%20atmosphere%2C%20silhouetted%20figure%20in%20spotlight%2C%20red%20accent%20highlights%2C%20cinematic%20documentary%20style%2C%20professional%20setup%2C%20mysterious%20mood&width=800&height=500&seq=media-01&orientation=landscape",
  },
  {
    id: 2,
    title: "【深度调查】选秀节目的暗箱操作全记录",
    duration: "35:12",
    views: "96万",
    image: "https://readdy.ai/api/search-image?query=Investigative%20documentary%20style%20scene%20with%20dark%20dramatic%20lighting%2C%20evidence%20board%20with%20red%20strings%2C%20cinematic%20atmosphere%2C%20mystery%20theme%2C%20professional%20photography%2C%20high%20contrast&width=800&height=500&seq=media-02&orientation=landscape",
  },
  {
    id: 3,
    title: "【数据解析】直播平台人气造假技术揭秘",
    duration: "22:08",
    views: "85万",
    image: "https://readdy.ai/api/search-image?query=Digital%20data%20analysis%20scene%20with%20dark%20theme%2C%20red%20glowing%20charts%20and%20graphs%2C%20cyber%20investigation%20atmosphere%2C%20cinematic%20lighting%2C%20technology%20and%20mystery%20combined%2C%20editorial%20style&width=800&height=500&seq=media-03&orientation=landscape",
  },
  {
    id: 4,
    title: "【专题报道】电竞选手转会市场乱象调查",
    duration: "41:30",
    views: "72万",
    image: "https://readdy.ai/api/search-image?query=Esports%20transfer%20market%20concept%20with%20dark%20dramatic%20lighting%2C%20player%20silhouettes%20with%20contract%20documents%2C%20red%20and%20gold%20accents%2C%20cinematic%20wide%20shot%2C%20professional%20photography&width=800&height=500&seq=media-04&orientation=landscape",
  },
];

export const rankingData = [
  {
    id: 1,
    rank: 1,
    title: "电竞顶流选手天价跳槽事件全纪录",
    heat: "1,286万",
    trend: "up",
    tag: "爆",
  },
  {
    id: 2,
    rank: 2,
    title: "三大选秀节目系统性数据造假",
    heat: "1,098万",
    trend: "up",
    tag: "热",
  },
  {
    id: 3,
    rank: 3,
    title: "国际裁判受贿链条深度调查",
    heat: "967万",
    trend: "up",
    tag: "热",
  },
  {
    id: 4,
    rank: 4,
    title: "知名品牌赞助数据造假被揭穿",
    heat: "823万",
    trend: "up",
    tag: "新",
  },
  {
    id: 5,
    rank: 5,
    title: "直播平台人气造假技术全揭秘",
    heat: "756万",
    trend: "down",
    tag: "",
  },
  {
    id: 6,
    rank: 6,
    title: "两大电竞赛事联盟公开对峙",
    heat: "689万",
    trend: "up",
    tag: "",
  },
  {
    id: 7,
    rank: 7,
    title: "选秀节目导师打分操控细节曝光",
    heat: "612万",
    trend: "down",
    tag: "",
  },
];